// Gets the data array needed for BarCharts when the xAxis is marked as type=category
// In this scenario each series is it's own unique bar
// So not broken up into categories e.g. repeating series for each client workflow
export const getBarChartSeriesFromItemNameCountShape = (data) => {
  const series = []

  data.forEach((d) => {
    series.push([d.itemName, d.count])
  })
  return series
}

export const createItemNameShape = (itemName, value) => {
  return {
    itemName,
    value,
  }
}



// WEBPACK FOOTER //
// ./src/utils/widget-utils.js